import { LoadingContainer } from '@melio/penny';
import { usePlans } from '@melio/subscriptions-api';
import { useSubscription } from '@melio/subscriptions-sdk';
import {
  SubscriptionCancelOrDowngradeActivity,
  SwitchSubscriptionToYearlyModalScreen,
  useSubscriptionPlanTier,
} from '@melio/subscriptions-ui';
import { useState } from 'react';

import { EditablePlanCard } from './Components/CurrentPlan/EditablePlanCard';
import { FreePlanCard } from './Components/CurrentPlan/FreePlanCard';

export const SubscriptionPlansSelect = () => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState<boolean>(false);
  const [isSwitchModalOpen, setIsSwitchModalOpen] = useState<boolean>(false);
  const { subscription } = useSubscription();
  const { isFetching, data: plans } = usePlans();

  const { freePlan } = useSubscriptionPlanTier();

  const isFreePlan = subscription.planId === freePlan?.id;

  if (!isFetching && !plans) {
    return null;
  }

  const onOpenCancelModal = () => setIsCancelModalOpen(true);
  const onCloseCancelModal = () => setIsCancelModalOpen(false);
  const onOpenSwitchModal = () => setIsSwitchModalOpen(true);
  const onCloseSwitchModal = () => setIsSwitchModalOpen(false);

  return (
    <LoadingContainer isLoading={isFetching}>
      {isFreePlan && <FreePlanCard />}
      {!isFreePlan && (
        <EditablePlanCard onOpenCancelModal={onOpenCancelModal} onOpenSwitchBillingCycleModal={onOpenSwitchModal} />
      )}
      <SubscriptionCancelOrDowngradeActivity
        isOpen={isCancelModalOpen}
        newPlanId={freePlan?.id}
        onClose={onCloseCancelModal}
      />
      <SwitchSubscriptionToYearlyModalScreen
        isOpen={isSwitchModalOpen}
        onClose={onCloseSwitchModal}
        onChange={() => {
          //TODO: implement switch to yearly flow
        }}
      />
    </LoadingContainer>
  );
};
